import React, { Component } from 'react';
import '../css/bootstrap.min.css';
import '../css/app.css';
import '../css/styles.css';
import app from '../base/api';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Select from '../tools/Select';
import Grid from '@mui/material/Grid';
import DatePicker from '../tools/DatePicker';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useSearchParams } from 'react-router-dom';
import ViaBariloche from '../img/ViaBariloche.jpg';
import Albus from '../img/Albus.jpeg';
import DonOtto from '../img/DonOtto.jpeg';
import ElRosarino from '../img/ElRosarino.jpeg';
import ElValle from '../img/ElValle.jpeg';
import Rutamar from '../img/Rutamar.jpeg';
import TigreIguazu from '../img/TigreIguazu.jpeg';
import ViaTac from '../img/ViaTac.jpeg';

const theme = createTheme();

var _ = require('lodash');

class Home extends Component {
  constructor (props) {
    super(props)
    this.map = null;
    this.state = {
      className: '',
      formOk: false,
      processing: false,
      distance: null,
      response: '',
      price: null,
      error: '',
      form: this.getEmptyForm(),
      logo: ViaBariloche,
      home: 'https://www.viabariloche.com.ar/',
      company: 'VB',
      sa: 'Vía Bariloche',
    }
  }

  getEmptyForm () {
    return {
      DireccionOrigen: '',
      DireccionDestino: '',
      LocalidadOrigen: '',
      LocalidadDestino: '',
      PaisOrigen: '',
      PaisDestino: '',
      Email: '',
      Telefono: '',
      FechaSalida: null,
      FechaRegreso: null,
      idBusTipo: null,
      Nombre: '',
      Apellido: '',
      Pasajeros: '',
      CUIT: '',
      SoloIda: false,
      MovimientosDestino: false,
      DestinoKm: '',
      Catering: false,
    }
  }

  async componentDidMount ()  {
    const searchParams = this.props.searchParams;
    const emp = searchParams.get('emp');
    if (emp == 'AL') {
      this.setState({logo: Albus, home: 'https://www.albus.com.ar/', company: emp, sa: 'Transportes Albus SRL'})
    }
    if (emp == 'DO') {
      this.setState({logo: DonOtto, home: 'https://www.donotto.com.ar/', company: emp, sa: 'Transportes Don Otto S.A.'})
    }
    if (emp == 'ER') {
      this.setState({logo: ElRosarino, home: 'https://elrosarino.com.ar/', company: emp, sa: 'El Rosarino'})
    }
    if (emp == 'EV') {
      this.setState({logo: ElValle, home: 'https://www.elvalle.com.ar/', company: emp, sa: 'Transportes El Valle S.A.'})
    }
    if (emp == 'RU') {
      this.setState({logo: Rutamar, home: 'https://rutamar.com.ar/', company: emp, sa: 'Rutamar'})
    }
    if (emp == 'TI') {
      this.setState({logo: TigreIguazu, home: 'https://www.tigreiguazu.com.ar/', company: emp, sa: 'Expreso Tigre Iguazú S.R.L.br'})
    }
    if (emp == 'VT') {
      this.setState({logo: ViaTac, home: 'https://www.viatac.com.ar/', company: emp, sa: 'González Tarabelli SA'})
    }
  }

  handleChange = (event, value) => {
    let form = this.state.form;
    form[event.target.id] = event.target.value;
    if (event.target.id == 'SoloIda') {
      form[event.target.id] = value;
    }
    if (event.target.id == 'MovimientosDestino') {
      form[event.target.id] = value;
    }
    if (event.target.id == 'Catering') {
      form[event.target.id] = value;
    }
    let formOk = this.isFormFilled();
    this.setState({
      form: form,
      formOk: formOk,
    });
  }

  isFormFilled () {
    for (let id in this.state.form) {
      if (id=='SoloIda') continue;
      if (id=='MovimientosDestino') continue;
      if (id=='Catering') continue;
      if (this.state.form.SoloIda && id=='FechaRegreso') continue;
      if (!this.state.form.MovimientosDestino && id=='DestinoKm') continue;
      if (!this.state.form[id]) return false;
    }
    return true
  }

  getQuote = async () => {
    this.setState({processing: true})
    var f = new FormData();
    f.append('data', JSON.stringify({form: this.state.form, company: this.state.company}));
    let res = await app.post('/api/get_price/', f, {});
    if (res) {
      let quote = res.quote;
      let form = this.getEmptyForm();
      let response = res.template;

      this.setState({
        form: form,
        formOk: false,
        distance: parseInt(quote.Km),
        price: parseInt(quote.Precio),
        processing: false,
        error: null,
        response: response,
      });
    } else {
      this.setState({
        error: 'No es posible cotizar',
        processing: false,
        price: null,
        distance: null,
        response: '',
      });
    }
  }


  render() {
    let distanceDiv;
    if (this.state.distance) {
      distanceDiv = <Typography component="h1" variant="h5">Disancia: {this.state.distance} Km</Typography>;
    }
    let priceDiv;
    if (this.state.price) {
      priceDiv = <Typography component="h1" variant="h5">Precio: ARS {this.state.price}</Typography>;
    }
    let errorDiv;
    if (this.state.error) {
      errorDiv = <Typography component="h1" variant="h5">Precio: ARS {this.state.error}</Typography>;
    }

    let processingDiv;
    if (this.state.processing) {
      processingDiv = <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={this.state.processing}>
        <CircularProgress color="inherit" />
      </Backdrop>
    }

    return (

      <main>
        <div className="container">
          <header className="d-flex flex-wrap align-items-center justify-content-center justify-content-md-between py-3 mb-4 ">
            <a href="/" className="d-flex align-items-center col-md-3 mb-2 mb-md-0 text-dark text-decoration-none">
              <img className="d-block mx-auto img-fluid" src={this.state.logo} alt="" ></img>
            </a>

            <ul className="nav col-12 col-md-auto mb-2 justify-content-center mb-md-0">
              <li><a href={this.state.home} className="nav-link px-2 link-secondary">Home</a></li>
            </ul>

          </header>
        </div>
        <div className="main-banner">
          <div className="container">
            <nav style={{"--bs-breadcrumb-divider": ">"}} aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><a href={this.state.home}>Home</a></li>
                <li className="breadcrumb-item active" aria-current="page">formulario</li>
              </ol>
            </nav>
            <div className="formulario">
              <div className="col-md-10 p-lg-5 mx-auto my-3 text-center">
                <img className="d-block mx-auto mb-4 img-fluid" src={this.state.logo} alt="" ></img>
                <h2>VIAJES ESPECIALES</h2>
                <p className="px-5 lead">Aquí podrás solicitar la cotización de tu viaje en unidades de última generación para viajes de media y larga distancia con fines turísticos, empresariales, educativos. Cotizá ahora tu recorrido, te ofrecemos viajes y traslados según tus necesidades:</p>
              </div>
              <div className="row g-5">
                <div className="col-md-12 col-lg-12 px-5 ">


        <ThemeProvider theme={theme}>
          {processingDiv}
          <Container component="main">
            <CssBaseline/>
            <Box
              sx={{
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Box noValidate sx={{ mt: 1 }} className={this.state.className}>
                <h4 className="mb-3">Datos de Contacto</h4>
                <Grid container spacing={2}>

                  <Grid key='Nombre' item xs={12} md={4}><TextField
                    margin="normal"
                    key='Nombre'
                    fullWidth
                    type='text'
                    id='Nombre'
                    value={this.state.form.Nombre || ''}
                    onChange={this.handleChange}
                    label='Nombre'
                  /></Grid>
                  <Grid key='Apellido' item xs={12} md={4}><TextField
                    margin="normal"
                    key='Apellido'
                    fullWidth
                    type='text'
                    id='Apellido'
                    value={this.state.form.Apellido || ''}
                    onChange={this.handleChange}
                    label='Apellido'
                  /></Grid>
                  <Grid key='CUIT/CUITL' item xs={12} md={4}><TextField
                    margin="normal"
                    key='CUIT'
                    fullWidth
                    type='text'
                    id='CUIT'
                    value={this.state.form.CUIT || ''}
                    onChange={this.handleChange}
                    label='CUIT'
                  /></Grid>

                  <Grid key='Email' item xs={12} md={4}><TextField
                    margin="normal"
                    key='Email'
                    fullWidth
                    type='text'
                    id='Email'
                    value={this.state.form.Email || ''}
                    onChange={this.handleChange}
                    label='Email'
                  /></Grid>
                  <Grid key='Telefono' item xs={12} md={4}><TextField
                    margin="normal"
                    key='Telefono'
                    fullWidth
                    type='text'
                    id='Telefono'
                    value={this.state.form.Telefono || ''}
                    onChange={this.handleChange}
                    label='Teléfono'
                  /></Grid>
                </Grid>
                     <hr className="my-4"></hr>
                     <h4 className="mb-3">Datos de Viaje</h4>

                <Grid container spacing={2}>
                  <Grid key='DireccionOrigen' item xs={12} md={4}><TextField
                    margin="normal"
                    key='DireccionOrigen'
                    fullWidth
                    type='text'
                    id='DireccionOrigen'
                    value={this.state.form.DireccionOrigen || ''}
                    onChange={this.handleChange}
                    label='Direccion de Origen'
                  /></Grid>
                  <Grid key='LocalidadOrigen' item xs={12} md={4}><TextField
                    margin="normal"
                    key='LocalidadOrigen'
                    fullWidth
                    type='text'
                    id='LocalidadOrigen'
                    value={this.state.form.LocalidadOrigen || ''}
                    onChange={this.handleChange}
                    label='Localidad de Origen'
                  /></Grid>
                  <Grid key='PaisOrigen' item xs={12} md={4}><TextField
                    margin="normal"
                    key='PaisOrigen'
                    fullWidth
                    type='text'
                    id='PaisOrigen'
                    value={this.state.form.PaisOrigen || ''}
                    onChange={this.handleChange}
                    label='Pais de Origen'
                  /></Grid>
                  <Grid key='DireccionDestino' item xs={12} md={4}><TextField
                    margin="normal"
                    key='DireccionDestino'
                    fullWidth
                    type='text'
                    id='DireccionDestino'
                    value={this.state.form.DireccionDestino || ''}
                    onChange={this.handleChange}
                    label='Direccion de Destino'
                  /></Grid>
                  <Grid key='LocalidadDestino' item xs={12} md={4}><TextField
                    margin="normal"
                    key='LocalidadDestino'
                    fullWidth
                    type='text'
                    id='LocalidadDestino'
                    value={this.state.form.LocalidadDestino || ''}
                    onChange={this.handleChange}
                    label='Localidad de Destino'
                  /></Grid>
                  <Grid key='PaisDestino' item xs={12} md={4}><TextField
                    margin="normal"
                    key='PaisDestino'
                    fullWidth
                    type='text'
                    id='PaisDestino'
                    value={this.state.form.PaisDestino || ''}
                    onChange={this.handleChange}
                    label='Pais de Destino'
                  /></Grid>
                  <Grid key='FechaSalida' item xs={12} md={4}>
                    <DatePicker
                      inputFormat="datetime"
                      id='FechaSalida'
                      value={this.state.form.FechaSalida || null}
                      onChange={this.handleChange}
                      label='Fecha Hora de Salida'
                    />
                  </Grid>
                  <Grid key='SoloIda' item xs={12} md={4}>
                    <FormControlLabel
                      label='Solo Ida'
                      control={
                        <Checkbox
                          id='SoloIda'
                          value={this.state.form.SoloIda}
                          onChange={this.handleChange}
                          label='Solo Ida'
                        />
                      }
                    />
                  </Grid>
                  <Grid key='FechaRegreso' item xs={12} md={4}>
                    <DatePicker
                      inputFormat="datetime"
                      id='FechaRegreso'
                      value={this.state.form.FechaRegreso || null}
                      disabled={this.state.form.SoloIda}
                      onChange={this.handleChange}
                      label='Fecha Hora de Regreso'
                    />
                  </Grid>
                  <Grid key='idBusTipo' item xs={12} md={4}>
                    <Select
                      id='idBusTipo'
                      relation='bustipos'
                      value={this.state.form.idBusTipo || ''}
                      onChange={this.handleChange}
                      label='Tipo de Unidad'
                    />
                  </Grid>
                  <Grid key='Pasajeros' item xs={12} md={4}><TextField
                    margin="normal"
                    key='Pasajeros'
                    fullWidth
                    type='text'
                    id='Pasajeros'
                    value={this.state.form.Pasajeros || ''}
                    onChange={this.handleChange}
                    label='Pasajeros'
                  /></Grid>
                  <Grid key='MovimientosDestino' item xs={12} md={4}>
                    <FormControlLabel
                      label='Movimientos en Destino'
                      control={
                        <Checkbox
                          id='MovimientosDestino'
                          value={this.state.form.MovimientosDestino}
                          onChange={this.handleChange}
                        />
                      }
                    />
                  </Grid>
                  <Grid key='DestinoKm' item xs={12} md={4}><TextField
                    margin="normal"
                    key='DestinoKm'
                    fullWidth
                    type='text'
                    id='DestinoKm'
                    value={this.state.form.DestinoKm || ''}
                    disabled={!this.state.form.MovimientosDestino}
                    onChange={this.handleChange}
                    label='Km en Destino por Dia'
                  /></Grid>
                  {/*<Grid key='Catering' item xs={12} md={4}>
                    <FormControlLabel
                      label='Catering'
                      control={
                        <Checkbox
                          id='Catering'
                          value={this.state.form.Catering}
                          onChange={this.handleChange}
                        />
                      }
                    />
                  </Grid>*/}

                  <Grid key='Save' item xs={12}>
                    <Button
                      type="button"
                      className="col-4 green-button btn btn-primary btn-lg mx-auto"
                      onClick={this.getQuote}
                      fullWidth
                      disabled={!this.state.formOk || this.state.processing}
                      variant="contained"
                      sx={{ mt: 3, mb: 2 }}
                    >
                      Cotizar
                    </Button>
                  </Grid>
                  <Grid key='Distance' item xs={12} id="">
                      <div dangerouslySetInnerHTML={{__html: this.state.response}}></div>
                  </Grid>
                  <Grid key='Error' item xs={12}>
                    {errorDiv}
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Container>
        </ThemeProvider>
        </div>
        </div>
        </div>
        </div>
        </div>


      <section className="footer" >
      <div className="container">
        <footer className="py-5">
          <div className="row">
            <div className="col-6 col-md-4 mb-3">
              <a href={this.state.home}>  <img className="d-block mx-auto img-fluid" src={this.state.logo} alt="" ></img>
              </a>
              <h5 className="phone"> <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-telephone" viewBox="0 0 16 16">
        <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
      </svg> 0810-333-7575 </h5>
            </div>

            <div className="col-6 col-md-4 offset-md-1 mb-3">
              <h5>ATENCIÓN AL CLIENTE</h5>
              <ul className="nav flex-column">
                <li className="nav-item mb-2"><a href={this.state.home + 'centro-atencion.php'} className="nav-link p-0 ">Centro de Atención Personalizada</a></li>
                <li className="nav-item mb-2"><a href={this.state.home + 'preguntas-frecuentes.php'} className="nav-link p-0 ">Preguntas Frecuentes</a></li>
                <li className="nav-item mb-2"><a href={this.state.home + 'contacto.php'} className="nav-link p-0 ">Contacto / Sugerencias</a></li>
              </ul>
            </div>

          </div>

          <div className="d-flex flex-column flex-sm-row justify-content-between py-4 my-4 border-top">
            <p>&copy; 2014 {this.state.sa}. All Right Reserved</p>
            <ul className="list-unstyled d-flex">
              <li className="ms-3"><a className="link-dark" href="https://twitter.com/viabariloche"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-twitter" viewBox="0 0 16 16">
                <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z"/>
                </svg></a>
              </li>
              <li className="ms-3"><a className="link-dark" href="https://www.facebook.com/viabarilocheoficial/"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-facebook" viewBox="0 0 16 16">
                <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"/>
                </svg></a>
              </li>
              <li className="ms-3"><a className="link-dark" href="https://www.instagram.com/viabarilocheok/"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-instagram" viewBox="0 0 16 16">
                <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z"/>
                </svg></a>
              </li>
            </ul>
          </div>
      </footer>
      </div>
      </section>

      </main>

    )
  }
}

// Wrapper component to provide search params to the class component
function HomeWithSearchParams(props) {
  const [searchParams] = useSearchParams();
  return <Home {...props} searchParams={searchParams} />;
}

export default HomeWithSearchParams;